import { flex } from "@/styles/mixins"
import { Modal } from "antd"
import styled from "styled-components"

export const SplitterWrap = styled.div`
  height: 100%;
  & .ant-splitter-panel {
    overflow-x: hidden;
    overflow-y: hidden;
  }

  & .ant-splitter-panel--wrap {
    padding: 16px;
    position: relative;
  }
`

export const ModalWrap = styled(Modal)`
  & .ant-modal-content {
    padding: 0;
  }
  & .ant-modal-header {
    padding: 16px;
    border-bottom: 2px solid #e1e1e1;
    margin-bottom: 0;
  }

  & .ant-modal-body {
    padding: 0;
    height: 70vh;
  }
  // & .ant-input-number-disabled{
  //   border: none;
  //   background: white;
  //   color: black;
  // }
  & .ant-input-disabled {
    border: none;
    background: white;
    color: black;
  }
  & .ant-picker-disabled {
    border: none;
    background: white;
    color: black;
    #priceForm_expiredAt {
      color: black;
    }
  }
`;

export const LogItemWrap = styled.div`
  margin-bottom: 12px;

  & .log-item--header {
    ${flex("row", "space-between", "flex-start")};
    gap: 12px;

    & .log-item--header--user {
      ${flex("row", "flex-start", "center")};
      min-width: 0;

      & .log-item--header--user-name {
        margin-left: 6px;
        min-width: 0;

        & span {
          font-size: 16px;
          color: #172b4d;
          font-family: var(--app-font-family) !important;
        }
      }
    }

    & .log-item--header--meta {
      ${flex("row", "flex-end", "center")};
      gap: 6px;
      flex-shrink: 0;

      & .log-item--header--actions {
        display: flex;
        gap: 6px;
        transition: opacity 0.2s ease;
      }

      & .log-item--action {
        border: none;
        background: transparent;
        padding: 0;
        cursor: pointer;
        font-size: 12px;
        font-weight: 400;
        color: rgb(169, 173, 186);
        line-height: 18px;

        &:hover {
          color: #7a294f;
        }
      }

      & .log-item--header--time {
        font-size: 12px;
        font-weight: 400;
        color: rgb(169, 173, 186);
      }
    }
  }

  & .log-item--body {
    margin-left: 36px;
    margin-top: 4px;
    width: calc(100% - 36px);
  }

  & .log-item--content {
    white-space: break-spaces;
    font-size: 14px;
    font-weight: 400;
    color: rgb(23, 43, 77);
    position: relative;
    width: 100%;

    & .ant-typography {
      margin-bottom: 0;
    }

    & span,
    & div {
      font-size: 14px;
      color: #172b4d;
      font-family: var(--app-font-family) !important;
    }
  }

  & .log-item--replies-toggle {
    border: none;
    background: transparent;
    padding: 0;
    cursor: pointer;
    font-size: 12px;
    line-height: 18px;
    color: rgb(108, 120, 140);

    &:hover {
      color: #7a294f;
    }
  }

  & .log-item--replies-list {
    margin-top: 8px;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  & .log-item--reply-row {
    padding-left: 10px;
    border-radius: 6px;
    background: #f7f8fb;
  }

  & .log-item--reply-row-header {
    ${flex("row", "space-between", "center")};
    gap: 8px;
  }

  & .log-item--reply-row-title {
    flex: 1;
    display: flex;
    justify-content: space-between;
    min-width: 0;
    font-size: 12px;
    line-height: 18px;
    color: rgb(108, 120, 140);
    word-break: break-word;
    gap: 8px;
  }

  & .log-item--reply-row-content {
    margin-top: 4px;
    white-space: break-spaces;
    word-break: break-word;
    font-size: 14px;
    line-height: 20px;
    color: rgb(23, 43, 77);
    font-family: var(--app-font-family) !important;
  }

  & .log-item--attachments {
    margin-top: 6px;
    max-width: 100%;
  }

`;

export const LogWrap = styled.div`
  height: 100%;
  overflow: hidden;

  display: flex;
  flex-direction: column;

  .log-list--wrap {
    flex: 1;
    overflow: auto;
    padding: 16px;
  }

  .log-create--wrap {
    border-top: 1px solid #e1e1e1;
    padding: 10px;
    flex-shrink: 0;

    .log-action-preview {
      ${flex("row", "space-between", "center")};
      margin-bottom: 8px;
      padding: 6px 10px;
      background: #f3f4f7;
      border-radius: 4px;
      gap: 8px;

      & .log-action-preview__main {
        min-width: 0;
        flex: 1;
      }

      & .log-action-preview__text {
        font-size: 12px;
        font-weight: 400;
        color: rgb(108, 120, 140);
        line-height: 18px;
      }

      & .log-action-preview__content {
        margin-top: 2px;
        font-size: 12px;
        font-weight: 400;
        color: rgb(23, 43, 77);
        line-height: 18px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      & .log-action-preview__close {
        border: none;
        background: transparent;
        color: rgb(169, 173, 186);
        cursor: pointer;
        font-size: 14px;
        line-height: 1;
        padding: 0;
        flex-shrink: 0;

        &:hover {
          color: #7a294f;
        }
      }
    }

    & .ant-input {
      font-size: 14px !important;
      resize: none;
    }
  }

  .log-options {
    padding: 4px 0 0;
    display: flex;
    justify-content: space-between;
    align-items: center;

    & .log-options__actions {
      display: flex;
      align-items: center;
      gap: 8px;
    }

    & .log-content-count {
      color: rgb(169, 173, 186);
      font-size: 12px;
      white-space: nowrap;
    }
  }
`;
